<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="编辑会员"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="头像">
				<img :src="item.avatar" width="90" height="90">
			</el-form-item>
			<el-form-item label="昵称">
				{{item.nick_name}}
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input type="number" v-model="item.mobile"></el-input>
			</el-form-item>
			<el-form-item label="会员级别">
				<el-select v-model="item.level" clearable placeholder="请选择" size="small">
					<el-option v-for="item in levelOptions" :key="item.value" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="推荐人">
				<div class="picBox" @click="changeUser">
					<div class="pictrue dis-flex flex-x-center flex-dir-column flex-y-center" v-if="item.referee">
						<div>
							{{item.referee.real_name}}
						</div>
						<div>[{{item.referee.user_id}}]</div>
					</div>
					<div class="upLoad acea-row row-center-wrapper" v-else>
						<Icon type="ios-camera-outline" size="26" class="iconfonts"/>
					</div>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
		<!-- 选择商品-->
		<el-dialog title="分销商列表" :visible.sync="dealerUserModals" width="1000px" @on-cancel="cancel">
			<dealerUserList ref="dealerUserList"  @getUser="getUser"></dealerUserList>
		</el-dialog>
	</div>
</template>
<script>
	import dealerUserList from '@/components/dealerUserList/index';

	export default {
		components: {dealerUserList },
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				levelOptions: [],
				rules: {},
				dealerUserModals: false
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ''
				res = await this.axios.post('/store/member.level/list', {
				})
				// 获取数据
				this.levelOptions = res.data.list

				res = await this.axios.get('/store/member/detail', {
					params:{
						id: this.id
					}
				})
				// 获取数据
				this.item = res.data.detail

				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.item.mobile) {
					if (!/^1\d{10}$/i.test(this.item.mobile)) return this.$message.error({
						title: '请输入正确的手机号码'
					});
				}
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let url = ''
				url = '/store/member/edit'
				this.item.id = this.id
				this.axios.put(url, {
					level: this.item.level,
					mobile: this.item.mobile,
					referee_id: this.item.referee_id,
					id: this.id
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
					this.goBack()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			changeUser () {
				this.dealerUserModals = true;
			},
			cancel: function () {
				this.dealerUserModals = false;
			},
			getUser: function (row) {
				this.item.referee_id = row.user_id
				this.item.referee = row
				this.cancel()
			},
		}
	}
</script>
<style scoped>
</style>
